import { adminApi } from "./adminApi";
export const agreementsApi = adminApi
  .enhanceEndpoints({ addTagTypes: ["Agreement", "AgreementTemplate"] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAgreements: builder.query({
        query: (params) => ({ url: "/agreements", params }),
        providesTags: ["Agreement"],
      }),
      getAgreement: builder.query({
        query: (id) => `/agreements/${id}`,
        providesTags: ["Agreement"],
      }),
      getAgreementTemplates: builder.query({
        query: () => "/agreements/templates",
        providesTags: ["AgreementTemplate"],
      }),
      uploadAgreementTemplate: builder.mutation({
        query: (body) => ({
          url: "/agreements/templates",
          method: "POST",
          body,
        }),
        invalidatesTags: ["AgreementTemplate"],
      }),
      createAgreement: builder.mutation({
        query: (bookingId) => ({
          url: "/agreements",
          method: "POST",
          body: { bookingId },
        }),
        invalidatesTags: ["Agreement"],
      }),
      saveAgreement: builder.mutation({
        query: ({ id, ...body }) => ({
          url: `/agreements/${id}`,
          method: "PUT",
          body,
        }),
        invalidatesTags: ["Agreement"],
      }),
      signAgreement: builder.mutation({
        query: ({ id, ...body }) => ({
          url: `/agreements/${id}/sign`,
          method: "POST",
          body,
        }),
        invalidatesTags: ["Agreement"],
      }),
      resendAgreement: builder.mutation({
        query: (id) => ({
          url: `/agreements/${id}/resend`,
          method: "POST",
          body: {},
        }),
        invalidatesTags: ["Agreement"],
      }),
    }),
  });
export const {
  useGetAgreementsQuery,
  useGetAgreementQuery,
  useGetAgreementTemplatesQuery,
  useUploadAgreementTemplateMutation,
  useCreateAgreementMutation,
  useSaveAgreementMutation,
  useSignAgreementMutation,
  useResendAgreementMutation,
} = agreementsApi;
